import React, {Component} from 'react';
import '../assets-css/global.css'
import '../components/styles/footer.css'
import logo from '../assents-img/logo.svg'
import {Link} from 'react-router-dom'
import {useTranslation, Trans} from 'react-i18next'

export default function Footer() {

    const { t } = useTranslation();
        return (
            <React.Fragment>
                <footer className='conteiner'>
                    <div className="footer-info-wrapper">
                        <div className='footer-info 1'>
                            <h3>{t('titleAbout')}</h3>
                            <hr/>
                            <Link to="/Nosotros">{t('homeSection2Title')}</Link> <br/>
                            <Link to="/Instalaciones">{t('titleFacilities')}</Link> <br/>
                        </div>
                        <div className='footer-info 2'>
                            <h3>{t('titleTreatments')}</h3>
                            <hr/>
                            <Link to="/endodoncia">{t('homeSection1Endo')}</Link> <br/>
                            <Link to="/periodoncia">{t('treatSectionPerio')}</Link> <br/>
                            <Link to="/cirugía-dental">{t('treatSectionSugery')}</Link> <br/>
                            <Link to="/implantes-dentales">{t('treatSectionImplant')}</Link> <br/>
                            <Link to="/estética-dental">{t('homeSection1Cosm')}</Link> <br/>
                            <Link to="/ortodoncia">{t('homeSection1Orto')}</Link>
                        </div>
                        <div className='footer-info 3'>
                            <h3>{t('titleContact')}</h3>
                            <hr/>
                            <p>
                                <Trans>{t('footerDirection')}</Trans>
                            </p>
                        </div>
                    </div>
                    <img className='logo-footer' src={logo} alt="logo"/> <br/>
                    {/* <img className='facebook-logo' src={require('./media/facebook-logo.svg')} alt="facebook"/> */}
                    <hr className='separator-footer'/>
                    <div className="footer-bottom">
                        <p>© {(new Date().getFullYear())} Clínica Sol Oeste. All rights reserved.</p>
                    </div>
                </footer>

            </React.Fragment>
        )
    }
